/**
 * Remove a DOM element; intended for removing IE form elements that appear in Blade templates but shouldn't appear on non-IE browsers
 *
 * @param {string} selector - the DOM element to remove
 */
function removeIeFormElement(selector) {
  const ieFormElement = document.querySelector(selector);

  ieFormElement.parentNode.removeChild(ieFormElement);
}

export default removeIeFormElement;



// WEBPACK FOOTER //
// ./scripts/util/removeIeFormElement.js